import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Component, createRef } from 'react';
import { Form } from 'react-bootstrap';
import { Editor } from 'react-bootstrap-editor';
import { renderToStaticMarkup } from 'react-dom/server';

import { t } from '../model/Translation';
import ReportTemplate from '../page/chart.mdx';

@observer
export class ReportTemplatePage extends Component {
    previewBox = createRef<HTMLElement>();

    @observable
    accessor previewHTML = '';

    @observable
    accessor editing = false;

    @observable
    accessor editingHTML = '';

    componentDidMount() {
        this.previewHTML =
            this.previewBox.current?.innerHTML ||
            renderToStaticMarkup(<ReportTemplate />);
    }

    render() {
        const { previewHTML, editing, editingHTML } = this;

        return (
            <div className="p-3 d-flex flex-column gap-3">
                <header className="d-flex align-items-center justify-content-end gap-2">
                    {t('preview')}
                    <Form.Check
                        type="switch"
                        onClick={() => (this.editing = !this.editing)}
                    />
                    {t('edit')}
                </header>

                {editing ? (
                    <Editor
                        defaultValue={editingHTML || previewHTML}
                        onChange={value => (this.editingHTML = value)}
                    />
                ) : editingHTML ? (
                    <article
                        dangerouslySetInnerHTML={{ __html: editingHTML }}
                    />
                ) : (
                    <article ref={this.previewBox}>
                        <ReportTemplate />
                    </article>
                )}
            </div>
        );
    }
}
